import { TYPE_CONFIG, CONTAINER_TYPES } from '../../constants';

export default function ItemChildren({ item, allItems, onChildStatusToggle, onEditItem }) {
  const directChildren = allItems
    .filter((i) => i.parentId === item.id)
    .sort((a, b) => (a.order || 0) - (b.order || 0));

  if (directChildren.length === 0) {
    return <div className="feature-card-children-empty">No child items</div>;
  }

  return (
    <div className="feature-card-children">
      {directChildren.map((child) => {
        const childConfig = TYPE_CONFIG[child.type] || TYPE_CONFIG.task;
        const ChildIcon = childConfig.icon;
        const isContainer = CONTAINER_TYPES.includes(child.type);

        if (isContainer) {
          return (
            <div key={child.id} className="feature-child-group">
              <div
                className="feature-child-requirement"
                onClick={(e) => { e.stopPropagation(); if (onEditItem) onEditItem(child); }}
                style={onEditItem ? { cursor: 'pointer' } : undefined}
              >
                <ChildIcon size={14} style={{ color: childConfig.color }} />
                <span>{child.title}</span>
                <span className={`feature-child-status status-badge status-${child.status}`}>
                  {child.status === 'done' ? 'Done' : child.status === 'in_progress' ? 'In Progress' : 'Not Started'}
                </span>
              </div>
              <ItemChildren item={child} allItems={allItems} onChildStatusToggle={onChildStatusToggle} onEditItem={onEditItem} />
            </div>
          );
        }

        const isDone = child.status === 'done';
        return (
          <div
            key={child.id}
            className={`feature-child-item${isDone ? ' feature-child-item--done' : ''}`}
            onClick={(e) => { e.stopPropagation(); if (onEditItem) onEditItem(child); }}
            style={onEditItem ? { cursor: 'pointer' } : undefined}
          >
            <input
              type="checkbox"
              className="feature-child-checkbox"
              checked={isDone}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => onChildStatusToggle(child.id, e.target.checked)}
            />
            <ChildIcon size={14} style={{ color: childConfig.color }} />
            <span className="feature-child-title">{child.title}</span>
            {child.storyPoints != null && <span className="sprint-item-points">{child.storyPoints}</span>}
          </div>
        );
      })}
    </div>
  );
}
